import { useMemo } from "react";
import { Player } from "@kaltura/mediaspace-shared-player";
import { HeroProps } from "../HeroProps";
import { CommonHeroLayout } from "../layout/CommonHeroLayout";

/* eslint-disable-next-line */
export interface VodHeroProps extends HeroProps {}

/**
 * Vod Hero component - always renders a player
 */
export function VodHero(props: VodHeroProps) {
    const { entry, playerConfig } = {
        ...props,
    };

    const media = useMemo(() => ({ entryId: entry.id, ks: playerConfig.ks as string }), [entry, playerConfig]);

    return (
        <CommonHeroLayout collapsedHero={props.collapse}>
            <Player media={media} config={playerConfig} className="kms-ds-media-page-player" />
        </CommonHeroLayout>
    );
}

export default VodHero;
